import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ENUMS from '../../../enums/index';
import { formatter, enumHelper } from '../../../utils';
import * as financialTransactionsActions from '../../../redux/financialTransactions/actions';
import {
  Modal,
  ModalHeader,
  ModalBody,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';

import Spin from '../../../components/loading';

import './financialTransactionDetails.scss';

const FinancialTransactionDetails = props => {
  const [activeTab, setActiveTab] = useState('1');

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  let { user, financialTransaction, payment } = props.financialTransactionDetails;

  let { financialTransactionDetailsLoading } = props;

  useEffect(() => {
    props.fetchFinancialTransactionDetails(props.financialTransactionId);
  }, []);

  return (
    <Modal id="financial-transaction-modal" size="lg" isOpen={props.isOpen}>
      <ModalHeader>
        <div className="row">
          <div className="col-11">{locales('titles.financial.transaction.details')}</div>
          <div className="col-1 text-left">
            <a
              href="#"
              className=""
              onClick={event => {
                event.preventDefault();
                props.closeModal();
              }}
            >
              <i className="fas fa-times"></i>
            </a>
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <Spin spinning={financialTransactionDetailsLoading}>
          {user ? (
            <div className="userInfo">
              <div className="row">
                <div className="col-1">
                  <label className="text-colon m-0">{locales('modal.user.full.name')}</label>
                </div>
                <div className="col-7">
                  <strong>{user.fullName}</strong>
                </div>
                <div className="col-2 text-left">
                  <label className="text-colon m-0">{locales('modal.user.mobile.number')}</label>
                </div>
                <div className="col-2 text-left">
                  <strong>{user.mobileNumber}</strong>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          <Nav pills className="customPills">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '1' })}
                onClick={() => {
                  toggle('1');
                }}
              >
                {locales('titles.financial.transaction')}
              </NavLink>
            </NavItem>
            {financialTransaction &&
              (financialTransaction.type ===
                ENUMS.FINANCIAL_TRANSACTION_TYPES.values.ONLINE_PAYMENT_BY_RESERVATION ||
                financialTransaction.type ===
                  ENUMS.FINANCIAL_TRANSACTION_TYPES.values.INCREASE_BY_ONLINE_PAYMENT) && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '2' })}
                  onClick={() => {
                    toggle('2');
                  }}
                >
                  {locales('titles.payment')}
                </NavLink>
              </NavItem>
            )}
          </Nav>
          <TabContent className="customTabContent" activeTab={activeTab}>
            <TabPane tabId="1">
              {financialTransaction ? (
                <div>
                  <div className="row">
                    <div className="col-8">
                      <label className="text-colon m-0">
                        {locales('fields.financial.transaction.type')}
                      </label>
                      <strong>
                        {enumHelper.convertEnumValueToTitle(
                          ENUMS.FINANCIAL_TRANSACTION_TYPES.list,
                          financialTransaction.type
                        )}
                      </strong>
                    </div>
                    <div className="col-4 text-left">
                      <label className="text-colon m-0">{locales('fields.createdAt')}</label>
                      <strong>{financialTransaction.createdAt}</strong>
                    </div>
                  </div>

                  <div className="credit">
                    <div className="row">
                      <div className="col-3">
                        <strong>
                          {formatter.numberWithCommas(financialTransaction.priorCredit)}
                        </strong>
                        <i className="fas fa-plus"></i>
                        <p>{locales('fields.priorCredit')}</p>
                      </div>
                      <div className="col-3">
                        <strong>{formatter.numberWithCommas(financialTransaction.amount)}</strong>
                        <i className="fas fa-equals"></i>
                        <p>{locales('fields.amount')}</p>
                      </div>
                      <div className="col-3">
                        <strong className="text-success">
                          {`${formatter.numberWithCommas(
                            financialTransaction.remainingCredit
                          )} ${locales(`tables.${payment.currency.toLowerCase()}`)}`}
                        </strong>
                      </div>
                      <div className="col-3">
                        <strong>
                          <label>{locales('fields.remainingCredit')}</label>
                          <i className="fas fa-arrow-left float-left"></i>
                        </strong>
                      </div>
                    </div>
                  </div>

                  <div className="boxGray">
                    <h6>{locales('fields.description')}</h6>
                    <div className="row boxGray">
                      <div className="col-12">{financialTransaction.description}</div>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </TabPane>
            <TabPane tabId="2">
              {payment ? (
                <div>
                  <div className="row mb-4">
                    <div className="col-6">
                      <label className="text-colon m-0">{locales('fields.bankPortalName')}</label>
                      <strong>
                        {enumHelper.convertEnumValueToTitle(
                          ENUMS.BANK_NAMES.list,
                          payment.bankPortalName
                        )}
                      </strong>
                    </div>
                    <div className="col-6 text-left">
                      <label className="text-colon m-0">{locales('fields.payment.status')}</label>
                      <strong
                        className={`text-${
                          payment.status === ENUMS.BANK_STATUS.values.PAID
                            ? 'success'
                            : payment.status === ENUMS.BANK_STATUS.values.PENDING
                              ? 'warning'
                              : 'danger'
                        }`}
                      >
                        <i
                          className={`fas fa-${
                            payment.status === ENUMS.BANK_STATUS.values.PAID
                              ? 'check'
                              : payment.status === ENUMS.BANK_STATUS.values.PENDING
                                ? 'exclamation'
                                : 'times'
                          }-circle pl-2`}
                        ></i>
                        {enumHelper.convertEnumValueToTitle(ENUMS.BANK_STATUS.list, payment.status)}
                      </strong>
                    </div>
                  </div>

                  <div className="borderGray mb-5">
                    <div className="row mb-3">
                      <div className="col-6">
                        <label className="text-colon m-0">{locales('fields.trackingNumber')}</label>
                        <strong className="direction-ltr">{payment.trackingNumber}</strong>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-6">
                        <label className="text-colon m-0">
                          {locales('fields.bankReferenceNumber')}
                        </label>
                        <strong>{payment.bankReferenceNumber}</strong>
                      </div>
                      <div className="col-6 text-left">
                        <label className="text-colon m-0">
                          {locales('fields.payment.createdAt')}
                        </label>
                        <strong>{payment.createdAt}</strong>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <label className="text-colon m-0">
                          {locales('fields.bankTracingNumber')}
                        </label>
                        <strong>{payment.bankTracingNumber}</strong>
                      </div>
                      <div className="col-6 text-left">
                        <label className="text-colon m-0">{locales('fields.paidAt')}</label>
                        <strong>{payment.paidAt}</strong>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`row mb-4 ${
                      payment.bankResponse && Object.keys(payment.bankResponse).length > 0
                        ? ''
                        : 'd-none'
                    }`}
                  >
                    <div className="col-12">
                      <pre>{JSON.stringify(payment.bankResponse, null, '  ')}</pre>
                    </div>
                  </div>
                  <div className="boxGray">
                    <h6>{locales('fields.description')}</h6>
                    <div className="row boxGray">
                      <div className="col-12">{payment.description}</div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-4 offset-md-8">
                      <div className="paymentAmount">
                        <label className="text-colon m-0">{locales('fields.payment.amount')}</label>
                        <strong>
                          {`${formatter.numberWithCommas(payment.amount)} ${locales(
                            `tables.${payment.currency.toLowerCase()}`
                          )}`}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </TabPane>
          </TabContent>
        </Spin>
      </ModalBody>
    </Modal>
  );
};
const mapStateToProps = state => {
  return {
    financialTransactionDetails:
      state.financialTransactionsReducer.financialTransactionDetails || {},
    financialTransactionDetailsLoading:
      state.financialTransactionsReducer.financialTransactionDetailsLoading,
    financialTransactionDetailsMessage:
      state.financialTransactionsReducer.financialTransactionDetailsMessage,
    financialTransactionDetailsFailed:
      state.financialTransactionsReducer.financialTransactionDetailsFailed,
    financialTransactionDetailsError:
      state.financialTransactionsReducer.financialTransactionDetailsError
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchFinancialTransactionDetails: id =>
      dispatch(financialTransactionsActions.fetchFinancialTransactionDetails(id))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinancialTransactionDetails);
